/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { AuthGuard } from '../auth.guard';

import { AdminComponent } from '../admin/admin.component';
import { AdminSystemComponent } from '../admin/admin-system/admin-system.component';
import { AdminAccountComponent } from '../admin/admin-account/admin-account.component';
import { AdminWorkflowComponent } from '../admin/admin-workflow/admin-workflow.component';
import { AdminEnrichComponent } from '../admin/admin-enrich/admin-enrich.component';
import { AdminFilterComponent } from '../admin/admin-filter/admin-filter.component';
import { AdminTypeOverrrideComponent} from '../admin/admin-type-overrride/admin-type-overrride.component';
import { AdminParserComponent } from '../admin/admin-parser/admin-parser.component';
import { AdminNbClassifierComponent } from '../admin/admin-nb-classifier/admin-nb-classifier.component';
import { AdminClassifierComponent } from '../admin/admin-classifier/admin-classifier.component';
import { AdminSubjectClassifierComponent } from '../admin/admin-subject-classifier/admin-subject-classifier.component';
import { AdminSpamClassifierComponent } from '../admin/admin-spam-classifier/admin-spam-classifier.component';
import { AdminUnsubClassifierComponent } from '../admin/admin-unsub-classifier/admin-unsub-classifier.component';
import { AdminHeaderClassifierComponent } from '../admin/admin-header-classifier/admin-header-classifier.component';
import { AdminNerComponent } from '../admin/admin-ner/admin-ner.component';
import { AdminEmailDetailComponent } from '../admin/admin-email-detail/admin-email-detail.component';
import { AdminJobsComponent } from '../admin/admin-jobs/admin-jobs.component';
import { AdminJobComponent } from '../admin/admin-job/admin-job.component';
import { AdminCleanupComponent } from '../admin/admin-cleanup/admin-cleanup.component';
import { AdminUtilitiesComponent } from '../admin/admin-utilities/admin-utilities.component';
import { AdminFailedTasksComponent } from '../admin/admin-failed-tasks/admin-failed-tasks.component';
import { AdminInboxComponent } from '../admin/admin-inbox/admin-inbox.component';
import { AdminCacheComponent } from '../admin/admin-cache/admin-cache.component';
import { AdminGoldensetComponent } from '../admin/admin-goldenset/admin-goldenset.component';
import { AdminMapComponent } from '../admin/admin-map/admin-map.component';
import { AdminWebPushComponent } from '../admin/admin-web-push/admin-web-push.component';

export const adminRouterConfig = [
  {
    path: 'admin/account',
    component: AdminComponent,
    canActivate: [AuthGuard],
    data: { role: 'sadmin', title: 'Admin', uiTitle: 'Admin' }
  },
  {
    path: 'admin/system',
    component: AdminSystemComponent,
    canActivate: [AuthGuard],
    data: { role: 'sadmin', title: 'System status', uiTitle: 'System status' }
  },
  {
    path: 'admin/account/:id',
    component: AdminAccountComponent,
    canActivate: [AuthGuard],
    data: { role: 'sadmin', title: 'Edit account', uiTitle: 'Edit account' }
  },
  {
    path: 'admin/map',
    component: AdminMapComponent,
    canActivate: [AuthGuard],
    data: { role: 'sadmin', title: 'MAP Utilities', uiTitle: 'MAP Utilities' }
  },
  {
    path: 'admin/workflow',
    component: AdminWorkflowComponent,
    canActivate: [AuthGuard],
    data: { role: 'sadmin', title: 'Workflow Fails', uiTitle: 'Workflow Fails' }
  },
  {
    path: 'admin/tasks',
    component: AdminFailedTasksComponent,
    canActivate: [AuthGuard],
    data: { role: 'sadmin', title: 'Failed Tasks', uiTitle: 'Failed Tasks' }
  },
  {
    path: 'admin/enrich',
    component: AdminEnrichComponent,
    canActivate: [AuthGuard],
    data: { role: 'sadmin', title: 'Enrich Fails', uiTitle: 'Enrich Fails' }
  },
  {
    path: 'admin/filter',
    component: AdminFilterComponent,
    canActivate: [AuthGuard],
    data: { role: 'sadmin', title: 'Filter Configuration', uiTitle: 'Filter Configuration' }
  },
  {
    path: 'admin/typeoverride',
    component: AdminTypeOverrrideComponent,
    canActivate: [AuthGuard],
    data: { role: 'sadmin', title: 'Type Override Configuration', uiTitle: 'Type Override Configuration' }
  },
  {
    path: 'admin/parser',
    component: AdminParserComponent,
    canActivate: [AuthGuard],
    data: { role: 'sadmin', title: 'Parser Configuration', uiTitle: 'Parser Configuration' }
  },
  {
    path: 'admin/classifier',
    component: AdminNbClassifierComponent,
    canActivate: [AuthGuard],
    data: { role: 'sadmin', title: 'Naive Bayes Classifier', uiTitle: 'Naive Bayes Classifier' }
  },
  {
    path: 'admin/customclassifier',
    component: AdminClassifierComponent,
    canActivate: [AuthGuard],
    data: { role: 'sadmin', title: 'Custom Classifier', uiTitle: 'Custom Classifier' }
  },
  {
    path: 'admin/subjectclassifier',
    component: AdminSubjectClassifierComponent,
    canActivate: [AuthGuard],
    data: { role: 'sadmin', title: 'Subject Classifier', uiTitle: 'Subject Classifier' }
  },
  {
    path: 'admin/spamclassifier',
    component: AdminSpamClassifierComponent,
    canActivate: [AuthGuard],
    data: { role: 'sadmin', title: 'Spam Classifier', uiTitle: 'Spam Classifier' }
  },
  {
    path: 'admin/unsubclassifier',
    component: AdminUnsubClassifierComponent,
    canActivate: [AuthGuard],
    data: { role: 'sadmin', title: 'Unsubscribe Classifier', uiTitle: 'Unsubscribe Classifier' }
  },
  {
    path: 'admin/headerclassifier',
    component: AdminHeaderClassifierComponent,
    canActivate: [AuthGuard],
    data: { role: 'sadmin', title: 'Header Classifier', uiTitle: 'Header Classifier' }
  },
  {
    path: 'admin/ner',
    component: AdminNerComponent,
    canActivate: [AuthGuard],
    data: { role: 'sadmin', title: 'Named Entity Recognition', uiTitle: 'Named Entity Recognition' }
  },
  {
    path: 'admin/ed/:id',
    component: AdminEmailDetailComponent,
    canActivate: [AuthGuard],
    data: { role: 'sadmin', title: 'Email Data', uiTitle: 'Email Data' }
  },
  {
    path: 'admin/jobs',
    component: AdminJobsComponent,
    canActivate: [AuthGuard],
    data: { role: 'sadmin', title: 'Job Data', uiTitle: 'Job Administration' }
  },
  {
    path: 'admin/job/:id',
    component: AdminJobComponent,
    canActivate: [AuthGuard],
    data: { role: 'sadmin', title: 'Job Data', uiTitle: 'Job Data' }
  },
  {
    path: 'admin/cleanup',
    component: AdminCleanupComponent,
    canActivate: [AuthGuard],
    data: { role: 'sadmin', title: 'Data Cleanup', uiTitle: 'Data Cleanup' }
  },
  {
    path: 'admin/inbox',
    component: AdminInboxComponent,
    canActivate: [AuthGuard],
    data: { role: 'sadmin', title: 'Inbox Status', uiTitle: 'Inbox Status' }
  },
  {
    path: 'admin/cache',
    component: AdminCacheComponent,
    canActivate: [AuthGuard],
    data: { role: 'uadmin', title: 'Cache Management', uiTitle: 'Cache Management' }
  },
  {
    path: 'admin/utilities',
    component: AdminUtilitiesComponent,
    canActivate: [AuthGuard],
    data: { role: 'uadmin', title: 'Utilities', uiTitle: 'Utilities' }
  },
  {
    path: 'admin/goldenset',
    component: AdminGoldensetComponent,
    canActivate: [AuthGuard],
    data: { role: 'uadmin', title: 'Goldenset', uiTitle: 'Goldenset' }
  },
  {
    path: 'admin/web-push',
    component: AdminWebPushComponent,
    canActivate: [AuthGuard],
    data: { role: 'sadmin', title: 'Web Push Test', uiTitle: 'Web Push Test' }
  }
];



// WEBPACK FOOTER //
// ./client/app/routes/admin.routes.ts